/*
 * @Author: Ning
 * @Date: ****** 13:23:08
 * @LastEditTime: 2023-09-06 15:44:31
 * @LastEditors: 郗志源 xizhiyuan@toseesoft.net
 * @Description: System Logs 日志
 * @Do not edit
 */

// 测试
// export const PAGE_NAME = "仅供测试";  //all title
// export const PAGE_COMPANY =  '仅供测试';
// export const PAGE_LOATION = '仅供测试';
// export const Imgbo = '仅供测试';
//正式
// export const PAGE_NAME = '奉贤区保障性租赁住房服务平台';  //all title
// export const PAGE_COMPANY = "上海奉贤保障性住房有限公司";
// export const PAGE_LOATION = "宝山区盘古路572号1号楼4楼 联系电话: 021-56100651";
// export const Imgbo = '';

// 定义常量，控制环境
// const NODE_ENV = 'development'
const NODE_ENV = 'production';
export const PAGE_NAME =
	NODE_ENV == 'production' ? '奉贤区保障性租赁住房服务平台' : '仅供测试'; //all title
export const PAGE_COMPANY =
	NODE_ENV == 'production' ? '上海奉贤保障性住房有限公司' : '仅供测试';
export const PAGE_LOATION =
	NODE_ENV == 'production' ? '上海市奉贤区南桥镇百秀路399弄' : '仅供测试';
export const Imgbo = NODE_ENV == 'production' ? '' : '仅供测试';

export const USERVALIDTIME = 30 * 60 * 1000; //过期时间
export const sendNationCaptchaName = 'publicHousing_baoshan_captcha'; //拓希短信
export const companyInfo = {
	companyCode: '013',
	companyName: '上海奉贤保障性住房有限公司',
};
export const NODE_API = '/fxApi/oms';

export const FILEACTIONURL = '/group1/upload'; //上传总文件的action(本地上传)
